import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ICommonNavigationClickHandler, IRouter, IShouldNavigateHandler } from '../types'
import { CommonNavigationClickHandlerSymbol, Router, ShouldNavigateHandlerSymbol } from '../symbols'
import type { ILinkClickHandler } from '@wix/thunderbolt-symbols'
import type { LinkProps, LinkTarget } from '@wix/thunderbolt-becky-types'
import type { IPreviewTooltipCallback } from 'feature-click-handler-registrar'
import { PreviewTooltipCallbackSymbol } from 'feature-click-handler-registrar'

const externalLinkRegex = new RegExp(/^(http|https):\/\/(.*)/)

const getLinkTypeFromHref = (href: string, router: IRouter) => {
	if (router.isInternalValidRoute(href)) {
		return 'PageLink'
	}

	if (externalLinkRegex.test(href)) {
		return 'ExternalLink'
	}

	if (href.startsWith('mailto:')) {
		return 'EmailLink'
	}
}

const createLinkPropsFromAnchor = (anchor: HTMLElement, router: IRouter): LinkProps => {
	const href = anchor.getAttribute('href') || ''
	const target = anchor.getAttribute('target') as LinkTarget
	const type = getLinkTypeFromHref(href, router)

	return {
		type,
		target,
	}
}

const navigationClickHandlerFactory = (
	router: IRouter,
	{ shouldNavigate }: IShouldNavigateHandler,
	{ getPreviewTooltipCallback }: IPreviewTooltipCallback,
	{ commonNavigationClickHandler }: ICommonNavigationClickHandler
): ILinkClickHandler => {
	return {
		handleClick: (anchor) => {
			const linkProps = createLinkPropsFromAnchor(anchor, router)

			if (!shouldNavigate(linkProps)) {
				const rect = anchor.getBoundingClientRect()
				const showTooltip = getPreviewTooltipCallback()
				showTooltip(rect, 'PREVIEW_PAGE_LINK_TOOLTIP')

				return true
			}

			return commonNavigationClickHandler(anchor)
		},
	}
}

export const NavigationClickHandler = withDependencies(
	[Router, ShouldNavigateHandlerSymbol, PreviewTooltipCallbackSymbol, CommonNavigationClickHandlerSymbol],
	navigationClickHandlerFactory
)
